// Modal: neue Kanzlei anlegen (Name/Kürzel/Plan + Kontakt) → Bot-Key einmalig.

import { useState, type FormEvent } from "react";

import { Button } from "@/components/Button";

import { createFirm, type CreateFirmResult } from "./api";
import { SecretBox } from "./SecretBox";

export function NewFirmForm({
  onDone,
  onCancel,
}: {
  onDone: () => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [plan, setPlan] = useState("starter");
  const [strasse, setStrasse] = useState("");
  const [plz, setPlz] = useState("");
  const [ort, setOrt] = useState("");
  const [telefon, setTelefon] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<CreateFirmResult | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (!name.trim() || !slug.trim()) return;
    setBusy(true);
    setError(null);
    try {
      setResult(
        await createFirm({
          name: name.trim(),
          slug: slug.trim(),
          plan,
          strasse: strasse.trim() || undefined,
          plz: plz.trim() || undefined,
          ort: ort.trim() || undefined,
          telefon: telefon.trim() || undefined,
          kontakt_email: email.trim() || undefined,
        })
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "Fehler beim Anlegen");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="op-modal-overlay" onClick={onCancel}>
      <div className="op-modal" onClick={(e) => e.stopPropagation()}>
        {result ? (
          <>
            <p className="op-ok">Kanzlei „{result.firm.name}" angelegt.</p>
            <SecretBox
              title={`Bot-Host-Key (${result.key_label})`}
              secret={result.bot_key}
              onDismiss={onDone}
            />
          </>
        ) : (
          <form onSubmit={submit}>
            <h2 className="op-h2">Neue Kanzlei</h2>
            <label className="op-label">
              Name
              <input
                className="op-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                autoFocus
                required
              />
            </label>
            <div className="op-form-row">
              <label className="op-label">
                Kürzel (Slug)
                <input
                  className="op-input"
                  value={slug}
                  onChange={(e) => setSlug(e.target.value.toLowerCase())}
                  placeholder="z. B. beco"
                  required
                />
              </label>
              <label className="op-label">
                Plan
                <select
                  className="op-input"
                  value={plan}
                  onChange={(e) => setPlan(e.target.value)}
                >
                  <option value="starter">Starter</option>
                  <option value="professional">Professional</option>
                  <option value="enterprise">Enterprise</option>
                </select>
              </label>
            </div>
            <label className="op-label">
              Adresse
              <input
                className="op-input"
                value={strasse}
                onChange={(e) => setStrasse(e.target.value)}
                placeholder="Straße + Nr."
              />
            </label>
            <div className="op-form-row">
              <label className="op-label">
                PLZ
                <input
                  className="op-input"
                  value={plz}
                  onChange={(e) => setPlz(e.target.value)}
                />
              </label>
              <label className="op-label">
                Ort
                <input
                  className="op-input"
                  value={ort}
                  onChange={(e) => setOrt(e.target.value)}
                />
              </label>
            </div>
            <div className="op-form-row">
              <label className="op-label">
                Telefon
                <input
                  className="op-input"
                  value={telefon}
                  onChange={(e) => setTelefon(e.target.value)}
                />
              </label>
              <label className="op-label">
                E-Mail
                <input
                  className="op-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </label>
            </div>
            {error && <p className="op-error">{error}</p>}
            <div className="op-form-actions">
              <Button
                variant="primary"
                type="submit"
                loading={busy}
                disabled={!name.trim() || !slug.trim()}
              >
                Anlegen
              </Button>
              <button type="button" className="op-btn-ghost" onClick={onCancel}>
                Abbrechen
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
